import React, {memo} from 'react';
import {application} from '@/settings';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {useTheme} from '@/contexts/ThemeContext';

const getComponent = (Src) => {
  if (typeof Src === 'string') {
    return <img className="m-4 cursor-pointer max-h-10" src={Src} alt={application.name}/>;
  }
  return <Src className="m-4 cursor-pointer max-h-10"/>;
};

const Logo = ({mini}) => {
  const {theme} = useTheme();
  return <Link to="/">
    <div className={`w-full flex items-center ${mini ? 'justify-center' : ''}`}>
      {mini ?
        getComponent(theme?.general?.favicon || application.logo.srcMin) :
        getComponent(theme?.general?.logo || application.logo.src)
      }
    </div>
  </Link>;
};

Logo.propTypes = {
  mini: PropTypes.any
};

export default memo(Logo);
